/**
 * @desc 绑定接口
 */
const URL = "/rantion-app-center";
import http, { updateResponse } from "@/http";
export type Response = defs.appCenter.Response;
export function request(
  body: defs.appCenter.PageViewBindRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/view/bind`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
